import { render } from "./ListeSecteurActivite.vue?vue&type=template&id=45845ac2&ts=true"
import script from "./ListeSecteurActivite.vue?vue&type=script&lang=ts"
export * from "./ListeSecteurActivite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__